import all from './all.vue'
import policyLibrary from './policyLibrary'
import qybsLibrary from './qybsLibrary'
import businessScene from './businessScene'
import project from './project'
import notice from './notice'

export {
    all,
    policyLibrary,
    qybsLibrary,
    businessScene,
    project,
    notice
}